import { isFeatureEnable } from 'common/js/features-enabling';
import { installShortcut } from 'common/js/shortcut-utils';
import { sendMraidAnalyticsTrack } from 'common/js/TrackAnalyticsHelper';
import { updateQueryStringParameters } from 'common/js/url-utils';
import { preventSpamCallsShared } from 'common/js/utils';
import {
  UserClickHandler,
  UserClickHandlerProps
} from 'common/stores/handlers/UserClickHandler';
import { triggerOgyOnAdClicked } from 'common/js/mraid-utils';
import { when } from 'mobx';
import { TIMERS } from 'common/stores/constants/timers.constant';
import { SkanStore } from 'common/stores/SkanStore';
import { encapsulateClickUrlIfNeeded } from '../../../../../common/js/click-utils';

export interface MraidClickHandlerProps extends UserClickHandlerProps {
  skanStore?: SkanStore;
}

export class MraidUserClickHandler extends UserClickHandler {
  private skanStore: SkanStore | undefined;

  constructor(props: MraidClickHandlerProps) {
    super(props);

    this.handleMraid = preventSpamCallsShared(this.handleMraid.bind(this));
    this.skanStore = props.skanStore;

    when(
      () => {
        const timer = this.uiTimerStore.timers.get(TIMERS.SKAN_TIMER);
        return Boolean(timer?.isFinished);
      },
      () => {
        if (!this.skanStore?.canOpenAfterTimeout) return;
        this.handleMraid(this.formatConfig.clickUrl, false, window.mraid.open);
      }
    );
  }

  handleMraid(
    url: string,
    isRedirected: boolean,
    mraidOpen: (url: string) => void = () => {}
  ) {
    installShortcut(this.formatOptions, this.formatConfig, {
      forceRedirectUrl: url
    });

    sendMraidAnalyticsTrack('format_click', true);
    this.analyticsStore.sendCreativeTrack('client_click');
    triggerOgyOnAdClicked();
    this.setUserHasClicked();

    const baseUrl = this.formatConfig.clickUrl;
    let clickUrl = isRedirected
      ? updateQueryStringParameters(baseUrl, {
          force_redirect: url,
          source: 'click'
        })
      : url;

    clickUrl = encapsulateClickUrlIfNeeded(clickUrl);

    if (this.skanStore?.open(clickUrl, mraidOpen)) return;

    if (
      isFeatureEnable('clearCloseCallbackAfterClick') &&
      !this.formatContext.isUserAcquisition
    ) {
      window.mraid.close = () => {};
    }
    this.mraidStore.manageMraidOpen(mraidOpen, clickUrl);
  }
}
